import script from "./AddAssetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAssetModal.vue?vue&type=script&setup=true&lang=js"

import "./AddAssetModal.vue?vue&type=style&index=0&id=320877b3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320877b3"]])

export default __exports__